var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInsuranceBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#14BF96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4062 12.0938L26.2812 14.5938C26.9688 14.9062 27.5 15.5625 27.5 16.375C27.4688 19.5 26.1875 25.1562 20.8125 27.75C20.2812 28 19.6875 28 19.1562 27.75C13.7812 25.1562 12.5 19.5 12.5 16.375C12.4688 15.5625 13 14.9062 13.6875 14.5938L19.5625 12.0938C19.6875 12.0312 19.8438 12 20 12C20.125 12 20.2812 12.0312 20.4062 12.0938ZM23.5312 18.5312H23.5C23.8125 18.25 23.8125 17.7812 23.5 17.4688C23.2188 17.1875 22.75 17.1875 22.4688 17.4688L19 20.9688L17.5312 19.5C17.2188 19.1875 16.75 19.1875 16.4688 19.5C16.1562 19.7812 16.1562 20.25 16.4688 20.5312L18.4688 22.5312C18.75 22.8438 19.2188 22.8438 19.5312 22.5312L23.5312 18.5312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsuranceBadge);
export default __webpack_public_path__ + "static/media/icon-insurance-badge.bd380dc383bba0a0842851ea92f92c4b.svg";
export { ForwardRef as ReactComponent };